import { useContext } from "react";
import { CartContext } from "../context/CartContext";

const CartItems = () => {
    const { cartItems, removeItem } = useContext(CartContext);

    // Renderización del carrito
    return (
        <div className="max-w-lg m-auto bg-zinc-900/80 border border-zinc-800 rounded-2xl p-4 mt-5">
            <h2 className="text-2xl">Carrito</h2>
            <div className="flex justify-between items-center bg-zinc-800 rounded-lg p-2 mt-4">
                <p>Evento</p>
                <p>Entrada</p>
                <p>Precio</p>
                <p>Cantidad</p>
                <p>.. </p>

            </div>
            {cartItems.map((item) => (
                <div
                    key={item.id}
                    className="flex justify-between items-center p-2 border border-zinc-800 bg-zinc-900 rounded-2xl my-2"
                >
                    <img
                        src={item.Event.img}
                        className="max-h-12 object-cover aspect-square rounded-full"
                    ></img>
                    <p className="truncate max-w-[150px]">{item.categoria}</p>
                    <p>${item.precio}</p>
                    <p className="px-2">{item.quantity}</p>
                    <p className="px-2 cursor-pointer"
                        onClick={()=>removeItem(item.id)}>x</p>
                </div>
            ))}
        </div>
    );
};

export default CartItems;
